import { ArrowLeft, ArrowRight } from 'iconsax-react';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const SectionHistory = () => {
  const { t } = useTranslation();
  const data = [
    {
      year: '2019',
      desc: t(
        'A team of young members, driven by the dream of using<br/> technology to shape the future, founded the company.'
      ),
    },
    {
      year: '2020',
      desc: t(
        'We explored fundraising opportunities to connect<br/> with investors and deliver our products to customers.'
      ),
    },
    {
      year: '2021',
      desc: t(
        'We focus resources on researching Bot Trading, shaping the development direction in the<br/> Blockchain industry, and laying the foundation for innovation.'
      ),
    },
    {
      year: '2022',
      desc: t(
        'We focus on acquiring customers in the Vietnamese domestic market<br/> and explanding Blockchain products.'
      ),
    },
    {
      year: '2023',
      desc: t(
        'We established a branch in Seoul, South Korea, affirming our leadership in global growth and<br/> development. This allows us to access markets in Korea, Japan, Russia & China.'
      ),
    },
    {
      year: '2025',
      desc: t(
        'We lead in algorithmic and quantitative trading, using AI and machine learning to drive innovation<br/> and expand our influence in the financial market, delivering sustainable value to clients.'
      ),
    },
  ];
  const getDesc = () => {
    const desc = data[active].desc;
    if (typeof window !== 'undefined' && window.innerWidth < 1024) {
      return desc.replace(/<br\s*\/?>/gi, ' ');
    }
    return desc;
  };
  const [active, setActive] = useState(0);
  const [fade, setFade] = useState(true);

  const handleNext = () => {
    setFade(false);
    setTimeout(() => {
      setActive((prev) => (prev + 1) % data.length);
      setFade(true);
    }, 300);
  };

  const handlePrev = () => {
    setFade(false);
    setTimeout(() => {
      setActive((prev) => (prev - 1 + data.length) % data.length);
      setFade(true);
    }, 300);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false);
      setTimeout(() => {
        setActive((prev) => (prev + 1) % data.length);
        setFade(true);
      }, 300);
    }, 5000);

    return () => clearInterval(interval);
  }, [data.length]);

  return (
    <div className="section-history">
      <div className="section-history__top">
        <div className="title-section">
          <p className="title">{t('History')}</p>
          <span className="tag">(06)</span>
        </div>
        <div className="arrow-left-and-right">
          <div className="btn-arrow" onClick={handlePrev}>
            <ArrowLeft size={28} color="#ffffff" />
          </div>
          <div className="btn-arrow" onClick={handleNext}>
            <ArrowRight size={28} color="#ffffff" />
          </div>
        </div>
      </div>
      <div className={`section-history__content${fade ? ' fade-in' : ' fade-out'}`}>
        <p className="number">{data[active].year}</p>
        <div className="desc" dangerouslySetInnerHTML={{ __html: getDesc() }} />
      </div>
      <div className="section-history__bottom">
        <div className="line">
          <div className="line-dot">
            {data.map((item, index) => (
              <div className={`dot ${index === active ? 'active' : ''}`} key={index} />
            ))}
          </div>
        </div>
        <div className="line-year">
          {data.map((item, index) => (
            <div className={`line-year__item ${index === active ? 'active' : ''}`} key={index}>
              {item.year}
            </div>
          ))}
        </div>
      </div>
      <div className="arrow-left-and-right mobile">
        <div className="btn-arrow" onClick={handlePrev}>
          <ArrowLeft size={28} color="#ffffff" />
        </div>
        <div className="btn-arrow" onClick={handleNext}>
          <ArrowRight size={28} color="#ffffff" />
        </div>
      </div>
    </div>
  );
};

export default React.memo(SectionHistory);
